export default __webpack_public_path__ + "static/media/e-wallet-icon-black.91517911.svg";